import { render, staticRenderFns } from "./AsiLabel.vue?vue&type=template&id=4143f461&scoped=true"
import script from "./AsiLabel.vue?vue&type=script&lang=ts"
export * from "./AsiLabel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4143f461",
  null
  
)

export default component.exports